import { Heading, SimpleGrid, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { VideoDetailCardSponsor } from '@/imports/ui/components/VideoDetailCardSponsor';

import { ISponsor } from './VideoDetailCardPresentational';

type IVideoDetailCardSponsorSectionProps = {
  sponsors: ISponsor[];
  hasSpeakers: boolean;
};

export const VideoDetailCardSponsorSection: React.FC<
  IVideoDetailCardSponsorSectionProps
> = (props) => {
  return (
    <Stack spacing="4">
      <Heading fontSize="md">Additional Sponsors</Heading>
      <SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing="4">
        {props.sponsors.map((sponsor) => {
          return (
            <VideoDetailCardSponsor
              key={sponsor._id}
              sponsorId={sponsor._id}
              name={sponsor.name}
              profileImageUrl={sponsor.profilePicture?.imageProxy || undefined}
            />
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};
